<template>
	<div id="auditTop" class="main-page-content">
		<PageHeaderLayout :isBack="true">
			<div style="background: #fff; padding: 20px 20px">
				<el-form
					:inline="true"
					:model="searchCondition"
					class="demo-form-inline"
				>
					<el-form-item label="任务名称">
						<el-input
							clearable
							v-model="searchCondition.recruit_post"
							placeholder="请输入任务名称"
						></el-input>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input
							clearable
							v-model="searchCondition.fullName"
							placeholder="姓名"
						></el-input>
					</el-form-item>
					<el-form-item label="联系人电话">
						<el-input
							clearable
							v-model="searchCondition.phone"
							placeholder="联系人电话"
						></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-select
							clearable
							v-model="searchCondition.deliver_status"
							placeholder="审核状态"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<DatePicker @dataSearch="dataSearch" />
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="searchButton">查询</el-button>
						<el-button
							style="margin-left: 24px"
							:loading="downloadLoading"
							type="primary"
							icon="el-icon-document"
							@click="handleDownload"
							>导出</el-button
						>
					</el-form-item>
				</el-form>
				<div style="marrgin: 0 20px">
					<div style="color: #f56c6c;margin-bottom: 20px;">
						tip:每月下发前需进行"任务交付"才可以下发
					</div>
					<el-table
						:data="tableData"
						style="width: 100%"
						:header-cell-style="{ background: '#fbfbfb' }"
					>
						<template v-if="activeName === '2'">
							<el-table-column
								prop="recruit_post"
								label="任务名称"
								align="center"
							></el-table-column>
							<el-table-column
								prop="fullName"
								label="姓名"
								align="center"
							></el-table-column>
							<el-table-column
								prop="sex"
								label="性别"
								align="center"
							></el-table-column>
							<el-table-column
								prop="age"
								label="年龄"
								align="center"
							></el-table-column>
							<el-table-column
								prop="phone"
								label="联系电话"
								align="center"
							></el-table-column>
							<el-table-column
								prop="deliver_submit_at"
								label="交付提交时间"
								align="center"
							></el-table-column>
						</template>

						<el-table-column prop="deliver_status" label="状态" align="center">
							<template slot-scope="scope">
								{{ scope.row.q_deliver_status }}
							</template>
						</el-table-column>
						<el-table-column
							prop="deliver_status"
							label="审核信息"
							align="center"
						>
							<template slot-scope="scope">
								{{ scope.row.deliver_at }}
								<div
									style="text-align: center; margin-top: 20px"
									v-if="scope.row.deliver_status === 3"
								>
									<span slot="footer" class="dialog-footer">
										<el-button
											@click="showBohui(scope.row)"
											size="mini"
											type="primary"
											>驳回意见</el-button
										>
									</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button
									v-if="scope.row.deliver_status == '1'"
									size="mini"
									type="primary"
									@click="taskClick(scope.row, 'examine')"
									>审核</el-button
								>
								<el-button size="mini" @click="taskClick(scope.row, 'edit')"
									>编辑</el-button
								>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<el-dialog
				title="驳回意见"
				:visible.sync="bohuiDialog.show"
				width="30%"
				@close="closeBohui"
			>
				<div>
					{{ bohuiDialog.data.deliver_message }}
				</div>
				<div style="text-align: center; margin-top: 20px">
					<span slot="footer" class="dialog-footer">
						<el-button @click="closeBohui" size="mini" type="primary"
							>确 认</el-button
						>
					</span>
				</div>
			</el-dialog>

			<el-pagination
				style="float: right"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="pagege.current_page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pagege.page_size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="pagege.total"
			></el-pagination>
		</PageHeaderLayout>
	</div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
export default {
	components: {
		DatePicker,
		PageHeaderLayout,
	},
	data() {
		return {
			query: {},
			shenheData: [],
			activeName: "2",
			options_text: [
				"未交付",
				"待审核",
				"交付通过",
				"交付未通过",
				"平台审核中",
				"平台审核未通过",
			],
			options: [
				{
					value: "1",
					label: "待审核",
				},
				{
					value: "2",
					label: "交付通过",
				},
				{
					value: "3",
					label: "交付未通过",
				},
				{
					value: "4",
					label: "平台审核中",
				},
				{
					value: "5",
					label: "平台审核未通过",
				},
			],
			searchCondition: {},
			pagege: {},
			currentPage2: "",
			id: "",
			Status: "",
			mission_content: "",

			userList: {
				textarea: "",
			},
			radio: 1,
			examinedialogVisible: false,
			taskseedialogVisible: false,
			tableData: [],
			ispage: 1,
			num: 10,

			downloadLoading: false,
			bohuiDialog: {
				show: false,
				data: {},
			},
		};
	},
	created() {
		this.query = this.$route.query;
		this.init();
	},

	methods: {
		closeBohui() {
			this.bohuiDialog = {
				show: false,
				data: {},
			};
		},
		showBohui(row) {
			this.bohuiDialog = {
				show: true,
				data: row,
			};
			console.log(this.bohuiDialog, "bohuiDialog");
		},
		async handleDownload() {
			this.downloadLoading = true;
			let list = await this.init("export");
			console.log(list, "list");
			if (list.length === 0) {
				this.$message.warning("暂无数据");
				this.downloadLoading = false;
				return;
			}
			import("@/excel/Export2Excel").then((excel) => {
				let sHeader = [
					"任务id",
					"任务名称",
					"姓名",
					"性别",
					"年龄",
					"联系电话",
					"交付提交时间",
					"状态",
					"审核时间",
					"驳回意见",
					"交付内容",
					"交付图片",
				];
				const data = this.formatJson(list);
				console.log(data, "data");
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `${time}`;
				excel.export_json_to_excel({
					header: sHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.exportType, //Optional
				});
				this.downloadLoading = false;
			});
		},
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let {
					id,
					recruit_post,
					fullName,
					sex,
					age,
					phone,
					deliver_submit_at,
					q_deliver_status,
					deliver_at,
					deliver_message,
					deliver_content,
					deliver_images,
				} = v;
				let arr = [
					id,
					recruit_post,
					fullName,
					sex,
					age,
					phone,
					deliver_submit_at,
					q_deliver_status,
					deliver_at,
					deliver_message,
					deliver_content,
					deliver_images,
				];

				return arr;
			});
		},
		// 搜索
		searchButton() {
			this.init();
		},
		//获取选中日期的值
		dataSearch(value) {
			console.log(value);
			this.searchCondition.time = {};
			this.searchCondition.time.start_time = value[0];
			this.searchCondition.time.end_time = value[1];
		},
		handleClick(tab) {
			this.activeName = tab.name;
			this.init();
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.num = val;
			this.ispage = 1;
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ispage = val;
			this.init();
		},
		//详情
		taskClick(row, type) {
			this.$router.push({
				path: "/deliveryReview/deliveryPersonnelDetail",
				query: { id: row.join_id, type },
			});
		},
		async init(type) {
			let objects = {
				current_page: this.ispage,
				page_size: this.num,
				examine_status: "1",
				deliver_status: this.searchCondition.deliver_status,
				recruit_post: this.searchCondition.recruit_post,
				time: this.searchCondition.time,
				phone: this.searchCondition.phone,
				fullName: this.searchCondition.fullName,
				recruit_task_id: this.query.id,
			};
			if (type === "export") {
				objects.page_size = 9999999;
			}
			let res = {};

			res = await this.$api.post_task_privatejoinList(objects);
			let { data, pages } = res;
			console.log(data, "321312312312");
			console.log(pages);

			let tableData = data.map((item) => {
				return {
					...item,
					q_deliver_status: this.options_text[item.deliver_examine_status],
				};
			});
			if (type === "export") {
				return tableData;
			}
			this.tableData = tableData;
			this.pagege = pages;
		},

		taskseeClick(row) {
			this.mission_content = row.mission_content || row.job_remark;
			console.log(row);
			this.taskseedialogVisible = true;
		},
		userClose() {},
		examineClick(row) {
			this.id = row.id;
			this.radio = 1;
			this.userList.textarea = "";
			this.examinedialogVisible = true;
		},
		async userInfo() {
			let obj = {
				examine_status: this.radio,
				examine_reason: this.userList.textarea,
			};
			console.log(obj, "obj");

			if (obj.examine_status == 2 && obj.examine_reason == "") {
				this.$message.error("请填写拒绝理由");
			} else {
				let Status = "";
				if (this.activeName === "1") {
					Status = await this.$api.postStatus(this.id, obj);
				} else {
					Status = await this.$api.postDaily_taskExamine(this.id, obj);
				}
				this.$nextTick(() => {
					if (Status) {
						this.$message.success("审核成功!");
						this.init();
						this.examinedialogVisible = false;
					}
				});
			}
		},
	},
};
</script>

<style scoped lang="scss">
.main-page-content {
	padding-bottom: 50px;
}
</style>
